import React, {useEffect, useState} from "react";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import {Badge, Col, DatePicker, Form, Input, Modal, Row, Spin, Table, TreeSelect, Typography} from "antd";
import {
    errorHandle,
    getDateRange,
    getDaysArray, openNotificationWithIcon,
} from "../../Function";
import moment from "moment";
import {danhSachChotCongApi, dieuChinhCongCaNhanApi} from "../../../api/getChamcong";
import ListTeamApi, { ListBoPhanApi } from "../../../api/getListTeam";
import {EditOutlined} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { DownloadTongCongApi } from "../../../api/getInfoData";

const { Text, Link } = Typography;

const validateMessages = {
	required: '${label} là bắt buộc.',
	types: {
	},
	number: {
	},
};
const ModalDieuChinhCong =({visible, onCancel, updateData, dataDieuChinh})=>{
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    useEffect(()=>{
        form.resetFields();
        if (visible && dataDieuChinh) {
            form.setFieldsValue({
                username: dataDieuChinh.username
            });

        };
    },[visible]);

    const onFinish = (values) => {
        dieuChinhCongCaNhanApi({
            id: dataDieuChinh.idChotcong,
            dieuchinh: values.edit,
        })
            .then(r=>{
                updateData();
                openNotificationWithIcon('success','Thành công','')
                onCancel();
            })
            .catch(err=>{
                errorHandle(err)
            })

    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);

    };



    return (
        <Modal title={"Điều chỉnh công"} visible={visible} onCancel={onCancel} footer={false}>
             <Form
                form={form}
                name="basic"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                validateMessages={validateMessages}
            >
                <Row >
                    <Col span={24}>
                        <Form.Item
                            label="Tên nhân viên"
                            name="username"
                        >
                            <Text strong>{dataDieuChinh.username}</Text>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            label="Điều chỉnh"
                            name="edit"
                            rules={[{ required: true }]}
                        >
                            <Input maxLength={100}/>
                        </Form.Item>
                    </Col>
                    {/*<Col span={24}>*/}
                    {/*    <Form.Item*/}
                    {/*        label="Ghi chú"*/}
                    {/*        name="note"*/}
                    {/*        rules={[{ required: true }]}*/}
                    {/*    >*/}
                    {/*        <Input maxLength={300}/>*/}
                    {/*    </Form.Item>*/}
                    {/*</Col>*/}
                </Row>

                <Row gutter={16}>
                    <Col offset={9}>
                        <Form.Item >
                            <Button type="success" htmlType="submit" className={'m-2'} disabled={loading}>Thêm</Button>
                            <Button onClick={onCancel}>Thoát</Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    )
}


export const ChotCong =()=> {
    const defaultPageSize = 50;
    const [pager, setPager] = useState({pageSize:defaultPageSize});
    const [data, setData] = useState([]);
    const [lsDate, setLsDate] = useState(getDateRange(moment(new Date())));
    const [lsTeam, setLsTeam] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState('');
    const [treeData,setTreeData] = useState([]);
    const [currentTeam, setCurrentTeam] = useState([]);
    const [currentSelectedDate, setCurrentSelectedDate] = useState(moment(new Date()));
    const [isShowDieuChinh, setIsShowDieuChinh] = useState(false);
    const [dataDieuChinh, setDataDetailDieuChinh] = useState([]);
    const userInfo = useSelector((state)=>state.getUserInfo.userInfo);

    const [lsBoPhan, setLsBoPhan] = useState([]);
    const [currentBoPhan, setCurrentBoPhan] = useState([]);
    const [treeDataBoPhan,setTreeDataBoPhan] = useState([]);
    const [lsAllTeam, setLsAllTeam] = useState([]);
    const [loading_page, setLoading_page] = useState(false);

    const columns = [
        // {
        //     title: "STT",
        //     dataIndex: "index",
        //     key: "index",
        //     render: (value, item, index) => ((pager.current || 1) - 1) * pager.pageSize + index + 1,
        //     sortDirections: ['descend', 'ascend', 'descend'],
        // },
        {
            title: "MSNV",
            dataIndex: "msnv",
            key: "msnv",
            className: 'highlight',
            align:'center',
            filterKey: 'msnv',
            type: 'text',
            canSearch: true
        },
        {
            title: "Nhân viên",
            dataIndex: "username",
            className: 'highlight',
            key: "username",
            align:'center',
            filterKey: 'username',
            type: 'text',
            canSearch: true
        },
        {
            title: "Công thực nhận",
            dataIndex: "congthucnhan",
            key: "congthucnhan",
            className: 'highlight',
            align:'center',
            filterKey: 'congthucnhan',
            type: 'text',
            canSearch: true
        },
        {
            title: "Tổng hợp OT",
            className: 'highlight',
            dataIndex: "tonghopOT",
            key: "tonghopOT",
            align:'center',
            filterKey: 'tonghopOT',
            type: 'text',
            canSearch: true
        },
        {
            title: "Lễ tết",
            dataIndex: "leTet",
            className: 'highlight',
            key: "leTet",
            align:'center',
            filterKey: 'leTet',
            type: 'text',
            canSearch: true
        },
        {
            title: "Công bù",
            dataIndex: "congBu",
            key: "congBu",
            align:'center',
            filterKey: 'congBu',
            className: 'highlight',
            type: 'text',
            canSearch: true
        },
        // {
        //     title: "Phép âm",
        //     dataIndex: "phepam",
        //     key: "phepam",
        //     className: 'highlight',
        //     align:'center',
        //     filterKey: 'phepam',
        //     type: 'text',
        //     canSearch: true
        // },
        {
            title: "Điều chỉnh",
            dataIndex: "dieuchinh",
            className: 'highlight',
            key: "dieuchinh",
            align:'center',
            filterKey: 'dieuchinh',
            type: 'text',
            render:(text, record) => handleCellDieuChinh(text, record, setIsShowDieuChinh, setDataDetailDieuChinh),
            canSearch: true
        },
        {
            title: "Tổng công",
            dataIndex: "tongcong",
            className:'lastColumn highlight',
            key: "tongcong",
            align:'center',
            filterKey: 'tongcong',
            type: 'text',
            canSearch: true
        },
    ]

    const handleCellDieuChinh = (text, record, setIsShowDieuChinh, setDataDetailDieuChinh) => {
        return (
            <>
                <div style={{textAlign:'center',width:'100%'}}>
                {text} <EditOutlined onClick={()=>{setDataDetailDieuChinh(record);setIsShowDieuChinh(true)}}/>
                </div>
            </>
        )

    };
    const fetchData = (params = {})=>{
        setLoading(true);
        danhSachChotCongApi({idTeam:params.idTeam,thoiGian:moment(params.thoiGian).format("YYYYMM")}).then(r=>{
            setData(r.data);
            setLoading(false);
        })
    }

    useEffect(() => {
        if (currentSelectedDate && currentTeam.length > 0) {
            fetchData({date:currentSelectedDate,idTeam:JSON.stringify(currentTeam),thoiGian:moment(currentSelectedDate).format("YYYYMM")})
        }
        if (currentTeam.length === 0) {
            setData([]);
        }

    }, [currentSelectedDate, currentTeam])

    const fetchListTeam = () =>{
        ListBoPhanApi().then(res=>{
            const arrTeam = userInfo.team_permissions.filter(item=>item.phanquyen__ten_pq === 'working_final_view')
                                                    .map((item,index)=>{
                                                        const idBoPhanForTeam = res.data.filter(itemBP =>  itemBP.team.some(itemT => itemT.id==item.team) )
                                                        if (idBoPhanForTeam.length != 0){
                                                            return {idTeam:item.team, team:item.team__tenTeam, idBoPhan: idBoPhanForTeam[0].id}
                                                        }
                                                        return false
                                                    }).filter(item => item != false);
            const uniqueArrTeam = [...new Map(arrTeam.map(item =>[item['idTeam'], item])).values()];
            uniqueArrTeam.sort(function(first, second) {
                return first['idTeam'] - second['idTeam'] ;
              });
            const arrIdTeam = uniqueArrTeam.map(item=>item.idTeam);
            const arrBoPhan = res.data.filter(({team}) => team.some(item => arrIdTeam.includes(item.id)) )
            if (arrBoPhan.length > 0) {
                setCurrentBoPhan([arrBoPhan[0].id]);
            }
            setLsBoPhan(arrBoPhan);
           
            setLsAllTeam(uniqueArrTeam);
            if (currentTeam.length === 0){
                setCurrentTeam([arrIdTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x))[0]]); // 200423 lấy element đầu tiên đặt trong list
            }
            setLsTeam(uniqueArrTeam.filter(x => arrBoPhan[0].team.map(item=>item.id).includes(x.idTeam)) );
        
        });
    }

    useEffect(()=>{
        if (userInfo && userInfo.team_permissions && userInfo.team_permissions.length > 0){
            fetchListTeam();
        }
    },[userInfo])

    const updateData=()=>{
        fetchData({idTeam:JSON.stringify(currentTeam),thoiGian:moment(new Date(currentSelectedDate)).format("YYYYMM")})
    }

    const onChangeBoPhan =(value)=>{
        if (value.length > 0) {
            setCurrentBoPhan(value);
            const lsTeamWith_BP = lsAllTeam.filter(x => value.includes(x.idBoPhan))
            setLsTeam(lsTeamWith_BP);
            setCurrentTeam([lsTeamWith_BP.map(item=>item.idTeam)[0]]); // 200423
        } else {
            setLsTeam([]);
            setCurrentBoPhan([]);
            setCurrentTeam([]);
        };
    }

    const tPropsConfig_BoPhan = {
        treeData:[{
            title:
                currentBoPhan.length > 0 ? (
                <span
                  onClick={() => {if (!loading){onChangeBoPhan([])}}}
                  className="style_SelectTeam"
                >
                  Bỏ chọn tất cả
                </span>
              ) : (
                <span
                  onClick={() => {if (!loading) {onChangeBoPhan(lsBoPhan.map(item=>item.id))}}}
                  className="style_SelectTeam"
                >
                  Chọn tất cả
                </span>
              ),
            value: "xxx",
            disableCheckbox: true,
            disabled: true,
            className: "style_treeTeam"
          },...treeDataBoPhan],
        value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
          onChange:onChangeBoPhan,
        treeCheckable: true,
        // showCheckedStrategy: SHOW_PARENT,
          maxTagCount:2,
        placeholder: 'Chọn bộ phận',
        style:{width:'fit-content',minWidth:200},
      };

    useEffect(()=>{
        const treeDataBoPhan = lsBoPhan.map(item=>{return {title: item.tenBophan, value: item.id, key: item.id}})
        setTreeDataBoPhan(treeDataBoPhan);
        if (currentBoPhan.length === 0){
            setCurrentBoPhan(lsBoPhan.map(item=>item.id));
        };
    },[lsBoPhan])

    const onChangeTeam =(value)=>{
        if (value.length > 0) {
            setCurrentTeam(value);
        } else {
            setCurrentTeam([]);
        };
    }

    const tPropsConfig = {
        treeData:[{
            title:
              !loading && (currentTeam.length > 0 ? (
                <span
                  onClick={() => setCurrentTeam([])}
                  className="style_SelectTeam"
                >
                  Bỏ chọn tất cả
                </span>
              ) : (
                <span
                  onClick={() => setCurrentTeam(lsTeam.map(item=>item.idTeam))}
                  className="style_SelectTeam"
                >
                  Chọn tất cả
                </span>
              )),
            value: "xxx",
            disableCheckbox: true,
            disabled: true,
            className: "style_treeTeam"
          },...treeData],
        value: treeData.length > 0 ? currentTeam : undefined,
          onChange:onChangeTeam,
        treeCheckable: true,
        // showCheckedStrategy: SHOW_PARENT,
          maxTagCount:2,
        placeholder: 'Chọn team',
        style:{width:'fit-content',minWidth:200},
      };

    useEffect(()=>{
          const treeDataTemp = lsTeam.map(item=>{return {title: item.team, value: item.idTeam, key: item.idTeam}})
          setTreeData(treeDataTemp);
        //   setCurrentTeam(lsTeam.map(item=>item.idTeam));
    },[lsTeam])

    const onChangeMonth =(date)=>{
        setCurrentSelectedDate(date)
        const lsDateTemp = getDateRange(date);
        setLsDate(lsDateTemp);
        // fetchData({date:date,idTeam:JSON.stringify(currentTeam),thoiGian:moment(date).format("YYYYMM")})
    };

    const onQuickChangeMonth=(type)=>{
        if (loading){
            return;
        }
        let monthChange;
        if (type === 'previous'){
            monthChange = moment(currentSelectedDate).subtract(1, 'month');
        } else {
            monthChange = moment(currentSelectedDate).add(1, 'month');
        }
        setCurrentSelectedDate(monthChange);
    }

    const handleChange =(pagination)=>{
        const currentPager = {...pager};
        currentPager.current = pagination.current;
        currentPager.pageSize = pagination.pageSize;
        setPager({...currentPager});
        fetchData({
            status:currentPager.status,
            page_size:pagination.pageSize,
            page:pagination.current,search
        })
    }
    const onExportTongHopCong =()=>{
        const fnFileDownload = require('js-file-download')
        const filename = "BangTongCong_" + moment(new Date()).format('YYYYMMDDHHMMSS')  + ".xlsx"
        setLoading_page(true);
        DownloadTongCongApi({
            idTeam:JSON.stringify(currentTeam),
            thoiGian:moment(currentSelectedDate).format("YYYYMM"),
            nam:moment(currentSelectedDate).year(),
        }).then(res=>{
            fnFileDownload(res.data, filename);
            setLoading_page(false);
        }) .catch(err=>{
            errorHandle(err);
            setLoading_page(false);
        })
    }

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0 font-size-18">Chốt công</h4>
                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link href="#">Nhân sự</Link>
                                </li>
                                <li className="breadcrumb-item active">Chốt công</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <Spin spinning={loading_page}>
                <div className="row">
                    <div className={'col-12 mb-2 d-sm-flex align-items-center justify-content-between'}>
                        <div className={'col'}>
                            <Button type="primary" className={'m-2 styleNtn_1'} onClick={()=>onQuickChangeMonth('previous')} title="Tuần trước">
                                <i className={'fa fa-arrow-left'}></i>
                            </Button>
                            <Button type="primary" className={'m-2 styleNtn_1'} onClick={()=>onQuickChangeMonth('next')} title="Tuần sau">
                                <i className={'fa fa-arrow-right'}></i>
                            </Button>
                            <DatePicker style={{borderRadius:10}} className={'m-2'} disabled={loading} onChange={onChangeMonth} picker={'month'} value={currentSelectedDate} format={'MM/YYYY'} allowClear={false}/>

                            <div className="styleBadge">
                                <Badge.Ribbon text="Bộ phận" color="gray" style={{color:"red"}}>
                                    <TreeSelect {...tPropsConfig_BoPhan} />
                                </Badge.Ribbon>
                            </div>
                            <div className="styleBadge">
                                <Badge.Ribbon text="Team" color="gray" style={{color:"red"}}>
                                    <TreeSelect {...tPropsConfig} />
                                </Badge.Ribbon>
                            </div>
                        </div>
                        <div>
                            <Button type="success" className={'m-2'} onClick={onExportTongHopCong}>Xuất dữ liệu
                            </Button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <Table
                        dataSource={data}
                        columns={columns}
                        loading={loading}
                        className={'custom-table-hover style-6'}
                        bordered={true}
                        size={'small'}
                        rowKey="id"
                        scroll={{y:500}}
                        onChange={handleChange}
                        // pagination={{
                        //     current: pager.current,
                        //     pageSize: pager.pageSize,
                        //     total: data.count,
                        //     showSizeChanger: true,
                        //     showQuickJumper: true,
                        //     pageSizeOptions: ['10', '15', '25', '50']
                        //
                        // }}
                        pagination={false}

                    />

                </div>
            </Spin>
             <ModalDieuChinhCong
                visible={isShowDieuChinh}
                onCancel={()=>setIsShowDieuChinh(false)}
                updateData={updateData}
                dataDieuChinh={dataDieuChinh}
            />
        </>
    )
}